/* FRAGRANTA B2B Landing Pages — fr-b2b.js
   Nur progressive Verbesserung: A–Z-Suche (clientseitiger Filter der
   serverseitig gerenderten Liste), mobiler Filter-Toggle der Bestandstabelle,
   Auto-Submit der Tabellenfilter. Alles funktioniert auch ohne JS. */
(function () {
  'use strict';

  function norm(s) {
    return (s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]/g, '');
  }

  /* ---- A–Z: Suche filtert Zeilen + Prioritätskarten, Aliasse via data-fr-alias ---- */
  document.querySelectorAll('[data-fr-az]').forEach(function (root) {
    var input = root.querySelector('[data-fr-az-search]');
    if (!input) return;
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-fr-az-row]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-fr-az-group]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-fr-az-card]'));
    var emptyNote = root.querySelector('[data-fr-az-empty]');

    function apply() {
      var q = norm(input.value);
      var visible = 0;
      rows.forEach(function (row) {
        var hay = norm(row.getAttribute('data-fr-name')) + norm(row.getAttribute('data-fr-alias'));
        var hit = !q || hay.indexOf(q) !== -1;
        row.style.display = hit ? '' : 'none';
        if (hit) visible++;
      });
      cards.forEach(function (card) {
        var hay = norm(card.getAttribute('data-fr-name')) + norm(card.getAttribute('data-fr-alias'));
        card.style.display = !q || hay.indexOf(q) !== -1 ? '' : 'none';
      });
      groups.forEach(function (group) {
        var any = group.querySelector('[data-fr-az-row]:not([style*="display: none"])');
        group.style.display = any ? '' : 'none';
      });
      if (emptyNote) emptyNote.style.display = q && visible === 0 ? 'block' : 'none';
    }
    input.addEventListener('input', apply);
  });

  /* ---- Bestandstabelle: mobiler Filter-Toggle + Auto-Submit ---- */
  document.querySelectorAll('[data-fr-filters-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = document.getElementById(btn.getAttribute('aria-controls'));
      if (!target) return;
      var open = target.classList.toggle('fr-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
  document.querySelectorAll('[data-fr-filter-form] select').forEach(function (sel) {
    sel.addEventListener('change', function () {
      sel.form.submit();
    });
  });
})();

/* ---- Brand Page (Design-Export 06.09.2026) ---- */

/* Kopier-Huerde in .fr-nocopy-Bereichen — Auswahl per CSS deaktiviert, hier
   zusaetzlich copy/contextmenu unterbunden. Links, Buttons, Formulare und
   Tastatur-/Screenreader-Bedienung bleiben unberuehrt. */
(function () {
  'use strict';
  /* Hero, Leiste und Tabelle laden diese Datei jeweils selbst — der Block
     darf trotzdem nur einmal laufen (sonst doppelte Listener). */
  if (window.__frBrandPageInit) return;
  window.__frBrandPageInit = true;
  function inNocopy(node) {
    if (!node || !node.closest) return false;
    if (!node.closest('.fr-nocopy')) return false;
    return !node.closest('a, button, input, select, textarea, summary, [contenteditable]');
  }
  document.addEventListener('copy', function (e) {
    var sel = document.getSelection();
    if (sel && sel.anchorNode && inNocopy(sel.anchorNode.parentElement || sel.anchorNode)) e.preventDefault();
  });
  document.addEventListener('contextmenu', function (e) {
    if (inNocopy(e.target)) e.preventDefault();
  });

/* Key-Point-Zahlen zaehlen in 2,5 s hoch (ease-out). Die Endzahl steht im
   Markup (data-fr-count = Textinhalt); bei prefers-reduced-motion bleibt sie
   unveraendert stehen. */
  var els = document.querySelectorAll('[data-fr-count]');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (els.length && !reduce) {
    var start = null, dur = 2500;
    var tick = function (now) {
      if (start === null) start = now;
      var p = Math.min(1, (now - start) / dur);
      var eased = 1 - Math.pow(1 - p, 3);
      els.forEach(function (el) {
        var n = parseInt(el.getAttribute('data-fr-count'), 10) || 0;
        el.textContent = Math.round(n * eased);
      });
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }

/* Stock-Order-Leiste der Brand Page: steht in einer eigenen Section und hat
   deshalb keinen hohen Container fuer CSS-sticky. Sobald sie aus dem
   Viewport scrollt, wird sie fixiert; ein Platzhalter haelt den Inhalt an
   Ort. (PDP: dort klebt sie per CSS innerhalb von .pd.) */
  var bar = document.querySelector('[data-fx-stockbar-follow]');
  if (!bar) return;
  var spacer = bar.parentElement ? bar.parentElement.querySelector('.fx-stockbar-spacer') : null;
  var top = 0;
  function measure() {
    var ref = (spacer && spacer.classList.contains('is-active')) ? spacer : bar;
    top = ref.getBoundingClientRect().top + window.scrollY;
  }
  function update() {
    var fixed = window.scrollY > top;
    if (fixed === bar.classList.contains('is-fixed')) return;
    if (spacer) {
      spacer.style.height = bar.offsetHeight + 'px';
      spacer.classList.toggle('is-active', fixed);
    }
    bar.classList.toggle('is-fixed', fixed);
  }
  measure();
  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', function () {
    if (spacer && spacer.classList.contains('is-active')) spacer.style.height = bar.offsetHeight + 'px';
    measure();
    update();
  });
})();
